/** Embedded symbol maps derived from symbol_table.yaml for browser + tests. */
/** Regenerate: deno run --allow-read --allow-write gen_symbol_table.ts */

export const SYMBOL_TABLE_LETTER_SYMBOLS = {
  "LOCATABLE.archetype_node_id": "id",
  "LOCATABLE.name": "na",
  "ARCHETYPED.archetype_id": "AX",
  "ARCHETYPED.template_id": "TP",
  "ARCHETYPED.rm_version": "rm",
  "DV_QUANTITY.magnitude_status": "mst",
  "DV_QUANTITY.magnitude": "mag",
  "DV_QUANTITY.units": "unit",
  "DV_QUANTITY.precision": "prc",
  "DV_QUANTITY.accuracy": "acc",
  "DV_CODED_TEXT.defining_code": "dc",
  "DV_TEXT.formatting": "xf",
  "DV_TEXT.hyperlink": "u",
  "DV_TEXT.mappings": "tm",
  "DV_TEXT.encoding": "enc",
  DV_BOOLEAN: "b",
  DV_IDENTIFIER: "id",
  DV_STATE: "st",
  DV_TEXT: "x",
  DV_CODED_TEXT: "c",
  DV_PARAGRAPH: "p",
  CODE_PHRASE: "C",
  TERM_MAPPING: "TM",
  DV_QUANTITY: "q",
  DV_COUNT: "co",
  DV_PROPORTION: "pr",
  DV_ORDINAL: "o",
  DV_INTERVAL: "iv",
  REFERENCE_RANGE: "RR",
  DV_DATE: "d",
  DV_TIME: "t",
  DV_DATE_TIME: "dt",
  DV_DURATION: "du",
  DV_MULTIMEDIA: "mu",
  DV_PARSABLE: "pa",
  DV_URI: "u",
  DV_EHR_URI: "eu",
  DV_SCALE: "sc",
  FEEDER_AUDIT: "FA",
  FEEDER_AUDIT_DETAILS: "FD",
  PARTY_PROXY: "PX",
  PARTY_IDENTIFIED: "PI",
  PARTY_RELATED: "PR",
  PARTY_SELF: "PS",
  PARTY_REF: "PF",
  OBJECT_REF: "OR",
  LOCATABLE_REF: "LR",
  OBJECT_VERSION_ID: "OV",
  PARTICIPATION: "PA",
  AUDIT_DETAILS: "AD",
  ATTESTATION: "AT",
  GENERIC_ID: "GX",
  INTERNET_ID: "IX",
  HIER_OBJECT_ID: "HX",
  UUID: "U",
  INTERVAL: "IV",
  ISM_TRANSITION: "IT",
  LINK: "LK",
  ITEM_SINGLE: "IS",
  ITEM_LIST: "IL",
  ITEM_TABLE: "TA",
  ITEM_TREE: "TR",
  CLUSTER: "CL",
  ELEMENT: "E",
  HISTORY: "HI",
  POINT_EVENT: "PE",
  INTERVAL_EVENT: "IE",
  EHR: "EH",
  EHR_STATUS: "ES",
  EHR_ACCESS: "EA",
  COMPOSITION: "CO",
  EVENT_CONTEXT: "EC",
  SECTION: "SE",
  ADMIN_ENTRY: "AE",
  GENERIC_ENTRY: "GE",
  OBSERVATION: "OB",
  EVALUATION: "EV",
  INSTRUCTION: "IN",
  ACTION: "AN",
  VERSIONED_OBJECT: "VO",
  CONTRIBUTION: "CB",
  "C_OBJECT.node_id": "ni",
  "C_OBJECT.rm_type_name": "rt",
  "C_OBJECT.occurrences": "oc",
  "C_ATTRIBUTE.rm_attribute_name": "an",
  "C_ATTRIBUTE.existence": "ex",
  "C_MULTIPLE_ATTRIBUTE.cardinality": "cd",
  "C_ARCHETYPE_ROOT.archetype_ref": "ar",
  "C_TERMINOLOGY_CODE.constraint": "tc",
  "CONSTRAINT_REF.reference": "rf",
  OPERATIONAL_TEMPLATE: "OT",
  C_COMPLEX_OBJECT: "CC",
  C_ARCHETYPE_ROOT: "CR",
  C_SINGLE_ATTRIBUTE: "SA",
  C_MULTIPLE_ATTRIBUTE: "MA",
  C_PRIMITIVE_OBJECT: "CP",
  ARCHETYPE_SLOT: "SL",
  CONSTRAINT_REF: "RF",
  C_COMPLEX_OBJECT_PROXY: "CPX",
  C_STRING: "XS",
  C_BOOLEAN: "XB",
  C_INTEGER: "XI",
  C_REAL: "XR",
  C_DATE: "XD",
  C_TIME: "XT",
  C_DATE_TIME: "XDT",
  C_DURATION: "XDU",
  C_TERMINOLOGY_CODE: "TC",
  CARDINALITY: "CD",
  ARCHETYPE_TERMINOLOGY: "ATM",
  C_ATTRIBUTE_TUPLE: "CT",
  C_PRIMITIVE_TUPLE: "PT",
  Boolean: "Fb",
  Integer: "Fi",
  Integer64: "Fj",
  Real: "Fr",
  Double: "Fd",
  Byte: "Fy",
  Octet: "Fo",
  Character: "Fc",
  String: "Fs",
} as const;

export const SYMBOL_TABLE_EMOJI_SYMBOLS = {
  "LOCATABLE.archetype_node_id": "🆔",
  "LOCATABLE.name": "🪧",
  "ARCHETYPED.archetype_id": "Ⓐ",
  "ARCHETYPED.template_id": "Ⓣ",
  "ARCHETYPED.rm_version": "⚙️",
  "DV_QUANTITY.magnitude_status": "🎛",
  "DV_QUANTITY.magnitude": "№",
  "DV_QUANTITY.units": "◌",
  "DV_QUANTITY.precision": "⋯",
  "DV_QUANTITY.accuracy": "±",
  "DV_CODED_TEXT.defining_code": "🏷️",
  "DV_TEXT.formatting": "🖹",
  "DV_TEXT.hyperlink": "🔗",
  "DV_TEXT.mappings": "⇄",
  "DV_TEXT.encoding": "🔡",
  DV_BOOLEAN: "🗹",
  DV_IDENTIFIER: "🪪",
  DV_STATE: "⚑",
  DV_TEXT: "🗉",
  DV_CODED_TEXT: "🗈",
  DV_PARAGRAPH: "🗎",
  CODE_PHRASE: "🏷️",
  TERM_MAPPING: "⇄",
  DV_QUANTITY: "🌡️",
  DV_COUNT: "🔢",
  DV_PROPORTION: "÷",
  DV_ORDINAL: "📶",
  DV_INTERVAL: "↔️",
  REFERENCE_RANGE: "↕",
  DV_DATE: "📅",
  DV_TIME: "⌚",
  DV_DATE_TIME: "📅⌚",
  DV_DURATION: "⏳",
  DV_MULTIMEDIA: "📷",
  DV_PARSABLE: "🔣",
  DV_URI: "🔗",
  DV_EHR_URI: "⤮",
  DV_SCALE: "↕️",
  FEEDER_AUDIT: "📩",
  FEEDER_AUDIT_DETAILS: "📩🔍",
  PARTY_PROXY: "👤❔",
  PARTY_IDENTIFIED: "👤🪪",
  PARTY_RELATED: "👤🧑‍🧑‍🧒",
  PARTY_SELF: "👤👈",
  PARTY_REF: "↦👤",
  OBJECT_REF: "↦📦",
  LOCATABLE_REF: "↦🧭",
  OBJECT_VERSION_ID: "📦🆔",
  PARTICIPATION: "👥",
  AUDIT_DETAILS: "🛃🔍",
  ATTESTATION: "✍",
  GENERIC_ID: "🃏🆔",
  INTERNET_ID: "🖧🆔",
  HIER_OBJECT_ID: "🌳🆔",
  UUID: "🌌🆔",
  INTERVAL: "⟷",
  ISM_TRANSITION: "⏭",
  LINK: "⤭",
  ITEM_SINGLE: "🔸",
  ITEM_LIST: "▤",
  ITEM_TABLE: "▦",
  ITEM_TREE: "🌳",
  CLUSTER: "📁",
  ELEMENT: "🔹",
  HISTORY: "📉",
  POINT_EVENT: "🞋",
  INTERVAL_EVENT: "🔛",
  EHR: "🏥",
  EHR_STATUS: "🏥⏻",
  EHR_ACCESS: "🏥🔐",
  COMPOSITION: "🖂",
  EVENT_CONTEXT: "🛈",
  SECTION: "📚",
  ADMIN_ENTRY: "🧑‍💼",
  GENERIC_ENTRY: "🦕",
  OBSERVATION: "👀",
  EVALUATION: "💭",
  INSTRUCTION: "💬",
  ACTION: "✅",
  VERSIONED_OBJECT: "🗃️",
  CONTRIBUTION: "📮",
  "C_OBJECT.node_id": "🆔",
  "C_OBJECT.rm_type_name": "🅁",
  "C_OBJECT.occurrences": "🔢",
  "C_ATTRIBUTE.rm_attribute_name": "📎",
  "C_ATTRIBUTE.existence": "∃",
  "C_MULTIPLE_ATTRIBUTE.cardinality": "#️⃣",
  "C_ARCHETYPE_ROOT.archetype_ref": "Ⓐ",
  "C_TERMINOLOGY_CODE.constraint": "🔖",
  "CONSTRAINT_REF.reference": "↦",
  OPERATIONAL_TEMPLATE: "🗂",
  C_COMPLEX_OBJECT: "🔐⬡",
  C_ARCHETYPE_ROOT: "🔐√",
  C_SINGLE_ATTRIBUTE: "🔐▸",
  C_MULTIPLE_ATTRIBUTE: "🔐⋮",
  C_PRIMITIVE_OBJECT: "🔐◆",
  ARCHETYPE_SLOT: "🗳",
  CONSTRAINT_REF: "🔐↦",
  C_COMPLEX_OBJECT_PROXY: "🔐🪞",
  C_STRING: "🔐📝",
  C_BOOLEAN: "🔐✓",
  C_INTEGER: "🔐𝕫",
  C_REAL: "🔐𝕣",
  C_DATE: "🔐📆",
  C_TIME: "🔐⌚",
  C_DATE_TIME: "🔐📅⌚",
  C_DURATION: "🔐⌛",
  C_TERMINOLOGY_CODE: "🔐🔖",
  CARDINALITY: "#️⃣",
  ARCHETYPE_TERMINOLOGY: "📖",
  C_ATTRIBUTE_TUPLE: "🔐⧉",
  C_PRIMITIVE_TUPLE: "🔐⮺",
  Boolean: "✓",
  Integer: "𝕫",
  Integer64: "ℤ",
  Real: "𝕣",
  Double: "ℝ",
  Byte: "⑧",
  Octet: "⓼",
  Character: "🔠",
  String: "📝",
} as const;

/** HTML5 short-dialect tag suffix overrides (`o-{suffix}`) when letter codes collide under lowercasing. */
export const SYMBOL_TABLE_HTML5_SHORT_TAGS = {
  DV_COUNT: "cnt",
  CODE_PHRASE: "cph",
  DV_INTERVAL: "ivl",
  DV_PARSABLE: "prs",
  DV_PROPORTION: "prp",
  DV_URI: "uri",
} as const;

/** OPT HTML5 short-dialect tag suffix overrides (`a-{suffix}`). */
export const SYMBOL_TABLE_OPT_HTML5_SHORT_TAGS = {
  C_COMPLEX_OBJECT_PROXY: "cpx",
  C_DATE_TIME: "xdt",
  C_DURATION: "xdu",
  C_TERMINOLOGY_CODE: "tc",
  ARCHETYPE_TERMINOLOGY: "atm",
  C_ATTRIBUTE_TUPLE: "cat",
  C_PRIMITIVE_TUPLE: "cpt",
} as const;

/** Prefix for foundation-backed C_* primitive constraint tags (emoji dialect). */
export const OPT_CONSTRAINT_EMOJI = "🔐" as const;

/** Foundation type → AOM C_* primitive (🔐 + foundation emoji). */
export const FOUNDATION_TO_C_PRIMITIVE = {
  Boolean: "C_BOOLEAN",
  Integer: "C_INTEGER",
  Real: "C_REAL",
  String: "C_STRING",
} as const;

export type TerminologyShortcut = { readonly prefix: string; readonly emoji: string };
export const TERMINOLOGY_SHORTCUTS: readonly TerminologyShortcut[] = [
  { prefix: "openehr::", emoji: "🌬️" },
  { prefix: "local::", emoji: "📍" },
  { prefix: "ISO_639-1::", emoji: "🗪" },
  { prefix: "ISO_3166-1::", emoji: "🌐" },
  { prefix: "IANA_character-sets::", emoji: "🔡" },
] as const;

export type MagnitudeStatusOperator = {
  readonly rm: string;
  readonly letter: string;
  readonly emoji: string;
};

/** RM magnitude_status value → HTML-safe wire symbols. Exact `=` is omitted on the wire. */
export const MAGNITUDE_STATUS_OPERATORS: readonly MagnitudeStatusOperator[] = [
  { rm: "<", letter: "⩻", emoji: "⩻" },
  { rm: ">", letter: "⩼", emoji: "⩼" },
  { rm: "<=", letter: "⩽", emoji: "⩽" },
  { rm: ">=", letter: "⩾", emoji: "⩾" },
  { rm: "~", letter: "~", emoji: "~" },
] as const;

/** RM magnitude_status for exact point values — never emitted in terse / emoji streams. */
export const MAGNITUDE_STATUS_EXACT_RM = "=" as const;

export type TerminologyFieldPromotion = {
  readonly field: string;
  readonly prefix: string;
  readonly emoji: string;
};
export const TERMINOLOGY_FIELD_PROMOTIONS: readonly TerminologyFieldPromotion[] = [
  { field: "language", prefix: "ISO_639-1::", emoji: "🗪" },
  { field: "territory", prefix: "ISO_3166-1::", emoji: "🌐" },
  { field: "encoding", prefix: "IANA_character-sets::", emoji: "🔡" },
] as const;
